import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahDashboard } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahDashboard } from '~support-at-home/models/sahDashboard';

// PRODA API connection dashboard — read-only aggregate counts (connection health, budget refresh
// staleness, claims in flight, reconciliation/amendment activity this month). GET only, no
// mutations.
export const sahDashboardApi = createApi({
  reducerPath: 'sahDashboardApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahDashboard }),
  tagTypes: ['sahDashboard'],
  endpoints: (builder) => ({
    getSahDashboard: builder.query<SahDashboard, void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<SahDashboard>(payload),
      providesTags: [{ type: 'sahDashboard', id: 'LIST' }],
    }),
  }),
});

export const { useGetSahDashboardQuery } = sahDashboardApi;
